export default __webpack_public_path__ + "static/media/jacobgarcia.deb27c0f.gif";